import { EventIds } from 'constants/eventIds';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { log } from 'utils/log';

/**
 * Strips out duplicate query params from the URL
 **/
export const useDeduplicateParams = (): void => {
    const { search } = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const params = new URLSearchParams(search);
        const newParams = new URLSearchParams();
        let doUpdate = false;

        for (const [key, value] of params) {
            if (newParams.getAll(key).find((elem) => elem === value)) {
                doUpdate = true;
            } else {
                newParams.append(key, value);
            }
        }

        if (doUpdate) {
            log.warn(
                `Encountered duplicate URL query params`,
                EventIds.DuplicateQueryParams,
            );

            navigate({ search: newParams.toString() });
        }
        // Only update when params change
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search, navigate]);
};
